import { z } from "zod";

export const GraphOfConvergingNodesSchema = z.array(
  z.object({
    nodeFrom: z.string(),
    nodeTo: z.string(),
    transactionHashes: z.array(z.string()),
    previousTransactionHashes: z.array(z.string()),
  }),
);
export type GraphOfConvergingNodes = z.infer<typeof GraphOfConvergingNodesSchema>;

export const GraphOfConvergingAddressesSchema = z.object({
  id: z.number(),
  campaign: z.string(),
  rewardVaultAddress: z.string(),
  depth: z.number(),
  graph: GraphOfConvergingNodesSchema,
  updatedAt: z.coerce.date(),
});
export type GraphOfConvergingAddresses = z.infer<typeof GraphOfConvergingAddressesSchema>;

export type RewardsVaultAddress = string;

// The data structure that will be saved in database : a graph of edges that
// share a common node at some point in the tree, by rewards vault address
export type GraphOfConvergingNodesByRewardsVaultAddress = {
  [key: RewardsVaultAddress]: GraphOfConvergingNodes;
};

export const GraphIdAndCampaignSchema = z.object({
  id: z.number(),
  campaign: z.string(),
});
export type GraphIdAndCampaign = z.infer<typeof GraphIdAndCampaignSchema>;

export const GraphIdAndCampaignArraySchema = z.array(GraphIdAndCampaignSchema);
export type GraphIdAndCampaignArray = z.infer<typeof GraphIdAndCampaignArraySchema>;

export const RemoveNodeFromGraphResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});
export type RemoveNodeFromGraphResponseDto = z.infer<typeof RemoveNodeFromGraphResponseSchema>;
